import React from "react";
import { motion } from "framer-motion";

const RINGS = [0.25, 0.5, 0.75, 1];

export default function RadarView({ jobs, radiusKm, onSelect, selectedId }) {
  return (
    <div
      data-testid="radar-sweep-canvas"
      className="relative w-full aspect-square max-w-[560px] mx-auto rounded-full border border-cyan-500/20 bg-slate-950/60 shadow-[0_0_60px_rgba(6,182,212,0.15)] overflow-hidden"
    >
      {/* rings */}
      {RINGS.map((r, i) => (
        <div key={i} className="radar-ring" style={{ width: `${r * 92}%`, height: `${r * 92}%` }}>
          <span className="absolute top-1 left-1/2 -translate-x-1/2 text-[10px] font-mono text-cyan-500/50">
            {Math.round(radiusKm * r)}km
          </span>
        </div>
      ))}

      {/* cross axes */}
      <div className="absolute top-1/2 left-0 w-full h-px bg-cyan-500/10" />
      <div className="absolute left-1/2 top-0 h-full w-px bg-cyan-500/10" />

      {/* sweep */}
      <div className="radar-sweep" />

      {/* center (you) */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
        <div className="w-3 h-3 rounded-full bg-teal-400 blip" />
        <span className="absolute top-4 left-1/2 -translate-x-1/2 text-[10px] font-mono text-teal-400 whitespace-nowrap">YOU</span>
      </div>

      {/* blips */}
      {jobs.map((job) => {
        const frac = Math.min(job.distance_km / radiusKm, 1) * 44;
        const rad = ((job.bearing || 0) * Math.PI) / 180;
        const x = 50 + frac * Math.sin(rad);
        const y = 50 - frac * Math.cos(rad);
        const color = job.urgent ? "#EF4444" : job.work_mode === "Remote" ? "#8B5CF6" : job.salary_max > 200000 ? "#F59E0B" : "#2DD4BF";
        const active = selectedId === job.id;
        return (
          <motion.button
            key={job.id}
            data-testid="radar-blip-item"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: Math.random() * 0.6, type: "spring", stiffness: 200 }}
            onClick={() => onSelect(job)}
            className="group absolute -translate-x-1/2 -translate-y-1/2 z-20"
            style={{ left: `${x}%`, top: `${y}%` }}
          >
            <span
              className={`block rounded-full transition-all ${active ? "w-4 h-4 ring-2 ring-white" : "w-2.5 h-2.5 group-hover:w-3.5 group-hover:h-3.5"}`}
              style={{ background: color, boxShadow: `0 0 10px ${color}` }}
            />
            <span className="absolute left-1/2 -translate-x-1/2 top-4 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-30 glass rounded-lg px-2.5 py-1.5 text-left">
              <span className="block text-[11px] font-semibold text-slate-100">{job.title}</span>
              <span className="block text-[10px] font-mono text-teal-400">{job.company} · {job.distance_km}km</span>
            </span>
          </motion.button>
        );
      })}
    </div>
  );
}
